'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.AuthenticationService
 * @description
 * # authentication.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .factory('AuthenticationService', function($rootScope, BaseService, localStorageService, eventsService,
    errorService, permissionService) {

    var service = new BaseService();

    var authentication = {
      isAuth: false,
      userName: ''
    };

    service.Login = login;
    service.Logout = clearCredentials;
    service.loggedIn = loggedIn;
    service.FillAuthData = fillAuthData;
    service.getUserInfo = getUserInfo;
    service.getAuthData = getAuthData;

    return service;

    function fillAuthData() {
      var authData = localStorageService.get('authorizationData');
      if (authData) {
        authentication.isAuth = true;
        authentication.userName = authData.userName;
        authentication.useRefreshTokens = authData.useRefreshTokens;
      }
    }

    function login(loginData) {
      var data = 'grant_type=password&username=' + loginData.userName + '&password=' + loginData.password;
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };
      if (!!loginData.tfaCode){
        headers['X-OTP'] = loginData.tfaCode;
      }

      return service.http.post(service.baseUrl + '/oauth/token', data, {
          headers: headers
        })
        .then(handleSuccess)
        .then(function (res) {
          return permissionService.Permissions()
          .then(eventsService.loggedIn);
        })
        .catch(handleError);
    }

    function clearCredentials() {
      localStorageService.remove('authorizationData');
      permissionService.clearPermissions();
      return eventsService.loggedOut();
    }

    function loggedIn() {
      var authData = localStorageService.get('authorizationData');
      return Boolean(authData);
    }

    function getUserInfo() {
      if (loggedIn()) {
          var authData = getAuthData();
          return {
            firstName: authData.firstName,
            lastName: authData.lastName,
            profilePictureUrl: authData.profilePictureUrl
          };
      }

      return undefined;
    }

    function getAuthData() {
      return localStorageService.get('authorizationData');
    }

    function setCredentials(response) {
      var loginData = response.data;
      return service.q.resolve(localStorageService.set('authorizationData', {
        token: loginData.access_token, // jshint ignore: line
        userName: loginData.userName,
        refreshToken: '',
        profilePictureUrl: loginData.profilePictureUrl,
        requiresTfa: Boolean(Number(loginData.requiresTfa)),
        roles: loginData.roles.split(','),
        tokenType: loginData.token_type, // jshint ignore: line
        expires: loginData.expires,
        firstName: loginData.firstName,
        lastName: loginData.lastName,
      }));
    }

    function handleSuccess(response) {
      return setCredentials(response);
    }

    function handleError(error, status) {
      error.status = error.status === 400 ? 401 : error.status;
      return service.q.reject(errorService.handleError(error))
      .then(clearCredentials);
    }
  });
